import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from '@piplapps/pipl-ui';
import { ProfileActions } from '../../../Redux/modules/profile/actions';
import { ProfileSelectors } from '../../../Redux/modules/profile/selectors';
import styles from './AccountActivation.module.less';
import LoadingButton from '../../../Components/LoadingButton';

const ActivateAccount = (props) => {
  return (
    <div className={styles.modalContainer}>
      <div className={styles.header} id="modal-title">
        {gettext('Move your account to a new organization')}
      </div>

      <div className={styles.popupText} id="modal-body">
        {gettext(
          `You've been invited to join ${props.orgName} by ${props.orgAdmin}. By accepting this invitation, your Pipl account will be moved to ${props.orgName}.`,
        )}
        {/* <br /> */}
        {/* {gettext(`By accepting this invitation, your Pipl account will be moved to ${props.orgName}.`)} */}
      </div>

      <div className={styles.buttonContainer}>
        <div className={styles.buttonWrapper}>
          <LoadingButton
            buttonClass="primary-blue"
            type="submit"
            onClick={() => props.handleMoveAccount(props.inviteId)}
            text={gettext('Move Account')}
            id="submit-button"
          />
        </div>
        <div className={styles.buttonWrapper} style={{ marginLeft: 20 }}>
          <Button
            buttonClass="secondary-blue"
            onClick={() => props.close()}
            text={gettext('Cancel')}
            id="cancel-button"
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    inviteId: ProfileSelectors.profileInviteIdSelector(state),
    orgAdmin: ProfileSelectors.profileInvitedBySelector(state),
    orgName: ProfileSelectors.profileInvitedByOrgNameSelector(state),
  };
};

const mapDispatchToProps = {
  handleMoveAccount: ProfileActions.moveAccount,
};

ActivateAccount.propTypes = {
  close: PropTypes.func,
  handleMoveAccount: PropTypes.func,
  orgAdmin: PropTypes.string,
  orgName: PropTypes.string,
  inviteId: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivateAccount);
